import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { AvatarGroup } from "components/DesignSystem/AvatarGroup/AvatarGroup";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { useAppDispatch } from "hooks/useAppDispatch";
import { pluralize } from "utils/pluralize";
import { motion } from "framer-motion";
import ChatCard from "components/DesignSystem/ChatCard/v2/ChatCard";
import {
  clearVendorEmailRequestsInChat,
  VendorEmailRequestsInChat,
} from "store/slices/vendorEmailRequestsInChat";
import { MentionIcon } from "components/icons/MentionIcon";

export const VendorEmailRequestInChatCard = ({
  vendors,
}: {
  vendors: VendorEmailRequestsInChat[];
}) => {
  const dispatch = useAppDispatch();

  return (
    <motion.div initial={{ y: 100 }} animate={{ y: 0 }} className="">
      <ChatCard.Content>
        <ChatCard.Header>
          <div className="t-flex t-justify-between t-items-center">
            <div className="t-flex t-gap-1.5 t-items-center">
              <MentionIcon />
              <span>Email Address Requested</span>
            </div>
            <Button
              size="xsmall"
              customType="ghost_icon"
              onClick={() => dispatch(clearVendorEmailRequestsInChat())}
            >
              <Cross />
            </Button>
          </div>
        </ChatCard.Header>
        <ChatCard.Body>
          <div className="t-flex t-flex-col t-gap-y-4">
            <div className="t-flex t-gap-2 t-items-center">
              <AvatarGroup max={2} variant="no-fill">
                {vendors.map((vendor) => (
                  <Avatar
                    key={vendor.id}
                    src={vendor.logo_url}
                    alt={vendor.name}
                  />
                ))}
              </AvatarGroup>
              <span className="t-text-subtext-sm">
                {pluralize(vendors.length, "vendor", "vendors")}
              </span>
            </div>
            <Button customType="primary" disabled block>
              Add email
            </Button>
          </div>
        </ChatCard.Body>
      </ChatCard.Content>
    </motion.div>
  );
};
